import { useAuth } from '../contexts/AuthContext.jsx'
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import API_URL from '../config/api.js';
import axios from 'axios';
import { useGooglePlacesAutocomplete } from '../hooks/useGooglePlaces';
import { getSubdomainConfig, getFilteredReferralSources, APP_MODES, getDomain, getSubdomain } from '../hooks/subdomainConfig.js';
import '../styles/ReferralForm.css';
import { getItemsForMode } from '../{components,pages,hooks,utils,styles}/constants/constants.js';
import BookingCalendar from '../components/BookingCalendar.jsx';


const REFERRAL_SOURCES = [
  { id: 'customer', name: 'Customer Referral', description: 'Refer a friend or family member', requiresPassword: false },
  { id: 'self', name: 'I\'m Interested', description: 'Fill out information for yourself', requiresPassword: false },
  { id: 'employee', name: 'Employee Referral', description: 'Internal employee referral', requiresPassword: true },
  { id: 'partner', name: 'Partner Referral', description: 'Business partner referral', requiresPassword: false },
];

const EMPLOYEE_PASSWORD = 'One$olar1';
console.log(`api_url ${API_URL}`)
const FORM_COMPLETION_OPTIONS = {
  default: [
    { id: 'fill-now', label: 'I will fill out the form now', description: 'Complete the form on behalf of the homeowner' },
    { id: 'send-link', label: 'Send link to homeowner', description: 'Email and text the form to the homeowner' },
    { id: 'both', label: 'Start now, homeowner finishes', description: 'Fill in what you know, send link for the rest' },
  ],
  self: [
    { id: 'fill-now', label: 'I will fill it out now', description: 'Complete the form right now' },
    { id: 'send-link', label: 'Send me the link', description: 'Email and text me the form to complete later' },
    { id: 'both', label: 'Start now, finish later', description: 'Fill in what I know now, complete the rest later' },
  ],
};

const PRODUCTS = [
  { id: 'solar', name: 'Solar Panels', icon: '☀️', requiresForm: true },
  { id: 'battery', name: 'Battery Storage', icon: '🔋', requiresForm: true },
  { id: 'roof', name: 'Roofing', icon: '🏠', requiresForm: true },
  { id: 'hvac', name: 'HVAC', icon: '❄️', requiresForm: false },
  { id: 'lighting', name: 'Permanent Lighting', icon: '💡', requiresForm: false },
  { id: 'windows', name: 'Windows', icon: '🪟', requiresForm: false },
  { id: 'ev-charger', name: 'EV Charger', icon: '⚡', requiresForm: true },
];

function ReferralForm() {
  const { user, logout, employee } = useAuth();
  const subdomainConfig = getSubdomainConfig();
  const mode = subdomainConfig.mode || APP_MODES.REFERRAL;
  const modeData = getItemsForMode(mode);
  const labels = subdomainConfig.labels || {};
  console.log(`domain Config: ${JSON.stringify(subdomainConfig)}`)
  console.log(`user: ${JSON.stringify(user)} | employee: ${JSON.stringify(employee)}`);
  const filteredReferralSources = getFilteredReferralSources(REFERRAL_SOURCES, subdomainConfig);
  const { category, partnerCode } = useParams();
  const [formData, setFormData] = useState({
    mode: mode,
    referralType: subdomainConfig?.defaultReferralType || '',
    employeePassword: '',
    employeeSearchTerm: '',
    selectedEmployee: null,
    formCompletionOption: subdomainConfig?.completionOption || '',
    referrerName: user?.name || '',
    referrerEmail: user?.email || '',
    referrerPhone: employee?.phone || '',
    referrerNotes: '',
    referringPartner: '',
    leadName: '',
    leadEmail: '',
    leadPhone: '',
    leadAddress: '',
    leadCity: '',
    leadState: '',
    leadZip: '',
    items: subdomainConfig?.product ? [subdomainConfig.product] : [],
    selectedForms: {},
    notify: ''
  });
  const [formsByProduct, setFormsByProduct] = useState({});
  console.log('📝 formData:', formData);
  console.log('Selected Forms');
  
  const [loading, setLoading] = useState(!!partnerCode);
  const [submitted, setSubmitted] = useState(false);
  const [showEmployeePassword, setShowEmployeePassword] = useState(false);
  const [passwordVerified, setPasswordVerified] = useState(false);
  const [employeeResults, setEmployeeResults] = useState([]);
  const [searchingEmployees, setSearchingEmployees] = useState(false);
  const [availableForms, setAvailableForms] = useState([]);
  const [showBookingCalendar, setShowBookingCalendar] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const hasEnergyAudit = formData.items.includes('energy-audit');
  const {button, setButton} = useState('Submit');
  const handlePlaceSelected = (placeData) => {
    setFormData(prev => ({
      ...prev,
      leadAddress: placeData.address,
      leadCity: placeData.city,
      leadState: placeData.state,
      leadZip: placeData.zip,
    }));
  };

  const { inputRef: addressInputRef, suggestions, loading: loadingSuggestions, showSuggestions, handleSuggestionClick, handleInputChange } = useGooglePlacesAutocomplete(handlePlaceSelected);
   
  
  
  useEffect(() => {
    const fetchForms = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/referrals/forms/available?mode=${mode}`);
        setFormsByProduct(response.data.formsByProduct || {});
        const defaults = {};
        Object.entries(response.data.formsByProduct || {}).forEach(([product, forms]) => {
          const defaultForm = forms.find(f => f.isDefault);
          if (defaultForm) {
            defaults[product] = defaultForm.id;
          }
        });
        setFormData(prev => ({ ...prev, selectedForms: defaults }));
      } catch (error) {
        console.error('Error fetching forms:', error);
      }
    };
    fetchForms();
  }, [mode]);


     const completionOptions = {
      'fill-now': 'Proceed to Form',
      'both': 'Proceed to Form',
      'send-link': 'Submit'
     }
    const completionMethod = completionOptions?.[formData?.formCompletionOption] || '';
    const hasSelectedForms = Object.values(formData.selectedForms).some(value => value);
    const buttonText = hasSelectedForms && completionMethod ? completionMethod : 'Submit';


  useEffect(() => {
    if (partnerCode) {
      fetchPartnerData(partnerCode);
      console.log(`Partner Code: ${partnerCode} || category: ${category}`)
    }
  }, [partnerCode]);
  
  const fetchPartnerData = async (code) => {

    try {
      console.log(`code: ${code}`)
      const response = await fetch(`${API_URL}/api/partners/${code}`);
      if (response.ok) {
        const data = await response.json();
        console.log(`Partner Data: ${JSON.stringify(data)}`)
        setFormData(prev => ({
          ...prev,
          referrerName: data.partner.referrerName,
          referrerPhone: data.partner.referrerPhone,
          referrerEmail: data.partner.referrerEmail,
          referringPartner: data.partner.companyName,
          ...(category === 'b2b' && {notify: data.partner.referrerPhone})
      }));
      } else {
        console.error('Partner not found');
      }
    } catch (error) {
      console.error('Error fetching partner:', error);
    } finally {
      setLoading(false);
    }
  };
 if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading form...</p>
      </div>
    );
  }
  const hasItemsWithForms = formData.items.some(itemId => {
    const item = modeData.items.find(i => i.id === itemId);
    return item && item.requiresForm;
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (name === 'referralType' && value === 'employee') {
      setShowEmployeePassword(true);
      setPasswordVerified(false);
      setEmployeeResults([]);
    } else if (name === 'referralType') {
      setShowEmployeePassword(false);
      setPasswordVerified(false);
      setEmployeeResults([]);
    }
  };

  const handlePasswordVerification = () => {
    if (formData.employeePassword === EMPLOYEE_PASSWORD) {
      setPasswordVerified(true);
    } else {
      alert('Incorrect password');
      setFormData(prev => ({ ...prev, employeePassword: '' }));
    }
  };

  const searchEmployees = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setEmployeeResults([]);
      return;
    }

    setSearchingEmployees(true);
    try {
      const response = await axios.get(`${API_URL}/api/referrals/employees/search`, {
        params: { q: searchTerm }
      });
      setEmployeeResults(response.data.employees || []);
    } catch (error) {
      console.error('Employee search error:', error);
      setEmployeeResults([]);
    } finally {
      setSearchingEmployees(false);
    }
  };

  const handleEmployeeSelect = (employee) => {
    setFormData(prev => ({
      ...prev,
      selectedEmployee: employee,
      referrerName: employee.name,
      referrerEmail: employee.email,
      referrerPhone: employee.phone,
    }));
    setEmployeeResults([]);
  };

  const handleItemToggle = (itemId) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.includes(itemId)
        ? prev.items.filter(i => i !== itemId)
        : [...prev.items, itemId]
    }));
  };

  const handleBookingComplete = (booking) => {
    setBookingData(booking);
    setShowBookingCalendar(false);
    console.log(`Booking Completed: ${booking}`);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if(hasEnergyAudit && !bookingData){
      setShowBookingCalendar(true);
      return;
    }
    setLoading(true);

   try {
      const submitData = { 
        ...formData,
        subdomain: subdomainConfig.subdomain,
        mode: mode,
        domain: getDomain(),
        booking: bookingData
      };
      const endpoint = subdomainConfig.apiEndpoint || '/api/referrals/submit';
      if (formData.referralType === 'self') {
        submitData.referrerName = formData.leadName;
        submitData.referrerEmail = formData.leadEmail;
        submitData.referrerPhone = formData?.leadPhone;
        submitData.referrerNotes = formData.referrerNotes;
        submitData.referringPartner = formData.referringPartner;
      }

      const headers = {
        'Content-Type': 'application/json'
      }

      const token = localStorage.getItem('authToken');

      if(token){
        headers['Authorization'] = `Bearer ${token}`
      }

      const response = await axios.post(
        `${API_URL}${endpoint}`, 
        submitData,
        {headers}  
      );
      
      if (response.data.success) {
         console.log('Response formUrls:', response.data.formUrls); 
        console.log('Form completion option:', formData.formCompletionOption); 
        const allForms = response.data.formUrls;
        if (formData.formCompletionOption === 'fill-now' && response.data.formUrls && allForms.length > 0) {
          
          
          console.log('All forms received:', allForms); 
          console.log('Number of forms:', allForms.length);
          if (allForms.length > 1) {
            const remaining = allForms.slice(1);
            console.log('Storing remaining forms:', remaining); 
            localStorage.setItem('remainingForms', JSON.stringify(remaining));
          }
          const domain = getDomain();
          const subdomain = getSubdomain();
          const formId = allForms[0].url.split('/').pop();
          const redirectUrl = `https://${subdomain}.${domain}.com/form/${formId}`;
          console.log(`Redirect Url: ${redirectUrl}`)
          window.location.href = redirectUrl;
        } else {

          setSubmitted(true);
          setTimeout(() => {
            window.location.href = `/thank-you/${mode}`;
          }, 2000);
        }
      }
    } catch (error) {
      console.error('Submission error:', error);
      alert('There was an error submitting your referral. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (showBookingCalendar) {
    return (
      <div className="referral-page">
        <div className="referral-hero">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="hero-content"
          >
            <img 
              src={subdomainConfig?.logo.source || 'https://i.imgur.com/DAg1a53.png'}
              alt={`${subdomainConfig.companyName} Logo`}
              style={{
                height: subdomainConfig?.logo.height ?? '200px',
                width: 'auto',
                maxWidth: '100%',
                objectFit: 'contain'
              }}
            />
          </motion.div>
        </div>
        
        <div className="container">
          <BookingCalendar 
            leadInfo={{
              name: formData.leadName,
              email: formData.leadEmail,
              phone: formData.leadPhone,
              address: `${formData.leadAddress}, ${formData.leadCity}, ${formData.leadState} ${formData.leadZip}`
            }}
            onBookingComplete={handleBookingComplete}
          />
        </div>
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="success-message">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200 }}
        >
          <div className="success-icon">✓</div>
          <h2>{`${mode[0].toUpperCase() + mode.slice(1)} Submitted!`}</h2>
          <p>{`Thank you for your ${mode} submission. We'll be in touch soon.`}</p>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="referral-page">
      <div className="referral-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="hero-content"
        >
          <img 
            src={subdomainConfig?.logo.source || 'https://i.imgur.com/DAg1a53.png'}
            alt={`${subdomainConfig.companyName} Logo`}
            style={{
              height: subdomainConfig?.logo.height ?? '200px',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain'
            }}
          />
           {mode === APP_MODES.ONBOARDING && user && (
            <div className="header-actions">
              <div className="user-info">
                <span className="user-name">{user.name}</span>
                <span className="user-email">{user.email}</span>
              </div>
              <button onClick={logout} className="logout-button">
                Logout
              </button>
            </div>
          )}
          {subdomainConfig.defaultReferralType === 'employee' && (
            <>
          <a href="/my-referrals" className="my-referrals-link">
            {`View My ${subdomainConfig?.labels?.lead || 'Referral'}s →`}
          </a>
          </>
          )}
        </motion.div>
      </div>

      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="form-wrapper"
        >
          <form onSubmit={handleSubmit} className="referral-form">
            {/* Referral Source Selection */}

              {!subdomainConfig.hideReferralTypeSelection && (
                <div className="form-section">
                  <h3>Referral Source</h3>
                  <div className="referral-types">
                    {REFERRAL_SOURCES.map((source) => (
                      <motion.label
                        key={source.id}
                        className={`type-card ${formData.referralType === source.id ? 'selected' : ''}`}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <input
                          type="radio"
                          name="referralType"
                          value={source.id}
                          checked={formData.referralType === source.id}
                          onChange={handleChange}
                          required
                        />
                        <div className="type-content">
                          <h4>{source.name}</h4>
                          <p>{source.description}</p>
                        </div>
                      </motion.label>
                    ))}
                  </div>
                </div>
              )}
            {/* Employee Password Verification */}
            {showEmployeePassword && !passwordVerified && (
              <div className="form-section">
                <h3>Employee Verification</h3>
                <div className="password-verification">
                  <div className="form-group">
                    <label>Employee Password *</label>
                    <div className="password-input-group">
                      <input
                        type="password"
                        name="employeePassword"
                        value={formData.employeePassword}
                        onChange={handleChange}
                        placeholder="Enter employee password"
                        required
                      />
                      <button
                        type="button"
                        onClick={handlePasswordVerification}
                        className="verify-button"
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Employee Search */}
            {(passwordVerified || subdomainConfig.defaultReferralType === 'employee') && formData.referrerName === '' && (
              <div className="form-section">
                <h3>Search Your Name</h3>
                <div className="form-group">
                  <label>Employee Name *</label>
                  <input
                    type="text"
                    name="employeeSearchTerm"
                    value={formData.employeeSearchTerm}
                    onChange={(e) => {
                      handleChange(e);
                      searchEmployees(e.target.value);
                    }}
                    placeholder="Start typing your name..."
                    required={subdomainConfig.contactSection}
                  />
                  {searchingEmployees && <p className="search-hint">Searching...</p>}
                  {employeeResults.length > 0 && (
                    <div className="employee-results">
                      {employeeResults.map((employee, index) => (
                        <div
                          key={index}
                          className="employee-result-item"
                          onClick={() => handleEmployeeSelect(employee)}
                        >
                          <strong>{employee.name}</strong>
                          <span>{employee.email}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {formData.selectedEmployee && (
                    <div className="selected-employee">
                      <p>✓ Selected: <strong>{formData.selectedEmployee.name}</strong></p>
                    </div>
                  )}
                </div>
              </div>
            )}


            {formData.referralType && 
            (formData.referralType !== 'employee' || formData.selectedEmployee || formData.referrerName ) && 
            subdomainConfig.defaultReferralType !== 'partner' && 
            subdomainConfig.product !== 'ev-charger' &&
            getSubdomain() !== 'schedule' && (
              <div className="form-section">
                <h3>{modeData.itemLabel}</h3>
                <p className="section-description">{modeData.itemDescription}</p>
                <div className="product-selection-list">
                  {modeData.items.map((item) => {
                    const availableForms = formsByProduct[item.name] || [];
                    const isSelected = formData.items.includes(item.id);
                    
                    return (
                      <div key={item.id} className="product-selection-item">
                        <div className="product-header">
                          <motion.button
                            type="button"
                            className={`product-toggle ${isSelected ? 'selected' : ''}`}
                            onClick={() => handleItemToggle(item.id)}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                          >
                            <div className="product-icon">
                              {item.icon.startsWith('http') ? (
                                <img src={item.icon} alt={item.name} className="product-icon-img" />
                              ) : (
                                item.icon
                              )}
                            </div>
                            <div className="product-name">{item.name}</div>
                            {isSelected && <span className="check-icon">✓</span>}
                          </motion.button>
                        </div>
                        
                        {/* Form Dropdown - Show when item is selected and has forms */}
                        {isSelected && availableForms.length > 0 && (
                          <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: 'auto' }}
                            exit={{ opacity: 0, height: 0 }}
                            className="form-dropdown-container"
                          >
                            <label>Select form for {item.name}:</label>
                            <select
                              value={formData.selectedForms[item.name] || ''}
                              onChange={(e) => setFormData(prev => ({
                                ...prev,
                                selectedForms: {
                                  ...prev.selectedForms,
                                  [item.name]: e.target.value
                                }
                              }))}
                              className="form-dropdown"
                            >
                              <option value="">No form required</option>
                              {availableForms.map(form => (
                                <option key={form.id} value={form.id}>
                                  {form.name} {form.isDefault ? '(Default)' : ''}
                                </option>
                              ))}
                            </select>
                          </motion.div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          {hasItemsWithForms && formData.referralType && !subdomainConfig.completionOption && (formData.referralType !== 'employee' || formData.selectedEmployee) && (
            <div className="form-section">
              <h3>How would you like to complete the form?</h3>
              <div className="completion-options">
                <motion.label
                  className={`option-card ${formData.formCompletionOption === 'fill-now' ? 'selected' : ''}`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <input
                    type="radio"
                    name="formCompletionOption"
                    value="fill-now"
                    checked={formData.formCompletionOption === 'fill-now'}
                    onChange={handleChange}
                    required
                  />
                  <div className="option-content">
                    <h4>{labels.formCompletion?.fillNow || 'Complete now'}</h4>
                    <p>Complete the form on behalf of the {labels.lead || 'homeowner'}</p>
                  </div>
                </motion.label>
                
                <motion.label
                  className={`option-card ${formData.formCompletionOption === 'send-link' ? 'selected' : ''}`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <input
                    type="radio"
                    name="formCompletionOption"
                    value="send-link"
                    checked={formData.formCompletionOption === 'send-link'}
                    onChange={handleChange}
                    required
                  />
                  <div className="option-content">
                    <h4>{labels.formCompletion?.sendLink || 'Send link'}</h4>
                    <p>Email and text the form to the {labels.lead || 'homeowner'}</p>
                  </div>
                </motion.label>
                
                <motion.label
                  className={`option-card ${formData.formCompletionOption === 'both' ? 'selected' : ''}`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <input
                    type="radio"
                    name="formCompletionOption"
                    value="both"
                    checked={formData.formCompletionOption === 'both'}
                    onChange={handleChange}
                    required
                  />
                  <div className="option-content">
                    <h4>{labels.formCompletion?.both || 'Start now, finish later'}</h4>
                    <p>Fill in what you know, send link for the rest</p>
                  </div>
                </motion.label>
              </div>
            </div>
          )}

            {/* Referrer Information - Hide for self referrals */}
            {formData.referralType && formData.referralType !== 'self' && (formData.referralType !== 'employee' || formData.selectedEmployee) && formData.referralType !== 'partner' && formData.referrerName === '' && (
              <div className="form-section">
                 {(mode === APP_MODES.ONBOARDING || mode === APP_MODES.INSTALL) ? (
                    <>
                      <h3>Your Employee Information</h3>
                      <div className="form-group">
                        <label>Search Your Name *</label>
                        <input
                          type="text"
                          name="employeeSearchTerm"
                          value={formData.employeeSearchTerm}
                          onChange={(e) => {
                            handleChange(e);
                            searchEmployees(e.target.value);
                          }}
                          placeholder="Start typing employee name..."
                          required
                        />
                        {searchingEmployees && <p className="search-hint">Searching...</p>}
                        {employeeResults.length > 0 && (
                          <div className="employee-results">
                            {employeeResults.map((employee, index) => (
                              <div
                                key={index}
                                className="employee-result-item"
                                onClick={() => handleEmployeeSelect(employee)}
                              >
                                <strong>{employee.name}</strong>
                                <span>{employee.email}</span>
                              </div>
                            ))}
                          </div>
                        )}
                        {formData.selectedEmployee && (
                          <div className="selected-employee">
                            <p>✓ Selected: <strong>{formData.selectedEmployee.name}</strong></p>
                            <p>Email: {formData.selectedEmployee.email}</p>
                            <p>Phone: {formData.selectedEmployee.phone}</p>
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    /* For referral mode, show regular fields */
                    <>
                      <h3>Your Information</h3>
                      <div className="form-grid">
                        <div className="form-group">
                          <label>Your Name *</label>
                          <input
                            type="text"
                            name="referrerName"
                            value={formData.referrerName}
                            onChange={handleChange}
                            placeholder="John Smith"
                            required
                            readOnly={subdomainConfig.contactSection}
                            className={subdomainConfig.contactSection ? 'readonly-input' : ''}
                          />
                        </div>
                        <div className="form-group">
                          <label>Your Email *</label>
                          <input
                            type="email"
                            name="referrerEmail"
                            value={formData.referrerEmail}
                            onChange={handleChange}
                            placeholder="john@example.com"
                            required
                            readOnly={!subdomainConfig.contactSection}
                            className={subdomainConfig.contactSection ? 'readonly-input' : ''}
                          />
                        </div>
                        <div className="form-group">
                          <label>Your Phone *</label>
                          <input
                            type="tel"
                            name="referrerPhone"
                            value={formData.referrerPhone}
                            onChange={handleChange}
                            placeholder="(555) 123-4567"
                            required
                            readOnly={subdomainConfig.contactSection}
                            className={subdomainConfig.contactSection ? 'readonly-input' : ''}
                          />
                        </div>
                        {subdomainConfig.companyName === 'car dealership' && (
                          <div className="form-group">
                            <label>Dealership</label>
                            <input
                              type="text"
                              name="referringPartner"
                              value={formData.referringPartner}
                              onChange={handleChange}
                              placeholder="Fast Cars"
                              required
                            />
                          </div>
                        )}
                        <div className="form-group full-width">
                          <label>Notes</label>
                          <textarea
                            name="referrerNotes"
                            value={formData.referrerNotes}
                            onChange={handleChange}
                            placeholder="Any notes for the team when reaching out to you or your referral"
                            rows="3"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}

            {/* Lead Information */}
            <div className="form-section">
              <h3>{formData.referralType === 'self' ? 'Your Information' : `${subdomainConfig?.labels?.lead || 'Referral'} Contact Information`}</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    name="leadName"
                    value={formData.leadName}
                    onChange={handleChange}
                    placeholder="Jane Doe"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="leadEmail"
                    value={formData.leadEmail}
                    onChange={handleChange}
                    placeholder="jane@example.com"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    name="leadPhone"
                    value={formData.leadPhone}
                    onChange={handleChange}
                    placeholder="(555) 987-6543"
                  />
                </div>
                <div className="form-group full-width">
                  <label>Address</label>
                  <div className="address-autocomplete">
                   <input
                      ref={addressInputRef}
                      type="text"
                      name="leadAddress"
                      value={formData.leadAddress}
                      onChange={(e) => {
                        handleChange(e); 
                        handleInputChange(e);
                      }}
                      placeholder="Start typing address..."
                      autoComplete="off"
                    />
                    {loadingSuggestions && <span className="loading-indicator">Searching...</span>}
                    {showSuggestions && suggestions.length > 0 && (
                      <div className="suggestions-dropdown">
                        {suggestions.map((suggestion) => (
                          <div
                            key={suggestion.place_id}
                            className="suggestion-item"
                            onClick={() => handleSuggestionClick(suggestion)}
                          >
                            {suggestion.description}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <p className="field-hint">Start typing to see address suggestions</p>
                </div>
                <div className="form-group">
                  <label>City</label>
                  <input
                    type="text"
                    name="leadCity"
                    value={formData.leadCity}
                    onChange={handleChange}
                    placeholder="Salt Lake City"
                  />
                </div>
                <div className="form-group">
                  <label>State</label>
                  <input
                    type="text"
                    name="leadState"
                    value={formData.leadState}
                    onChange={handleChange}
                    placeholder="UT"
                    maxLength="2"
                  />
                </div>
                <div className="form-group">
                  <label>ZIP Code</label>
                  <input
                    type="text"
                    name="leadZip"
                    value={formData.leadZip}
                    onChange={handleChange}
                    placeholder="84101"
                    maxLength="5"
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <motion.button
              type="submit"
              className="submit-button"
              disabled={
                loading || 
                formData.items.length === 0 ||
                ((mode === APP_MODES.ONBOARDING || mode === APP_MODES.INSTALL || mode === APP_MODES.EMPLOYEES) && !formData.selectedEmployee && !formData.referrerName )
              }
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {loading ? 'Submitting...' : buttonText}
            </motion.button>
          </form>
        </motion.div>
      </div>
    </div>
  );
}

export default ReferralForm;